<section id="como-funciona" class="section section-light">
	<div class="container">
		<h2>Cómo funciona</h2>
		<p class="section-lead">Una implementación simple y un uso diario pensado para que tu equipo trabaje con más
			orden y claridad.</p>

		<div class="steps-grid">
			<article class="step-card">
				<span>01</span>
				<h3>Alta y configuración</h3>
				<p>Creás tu cuenta, configurás tu negocio y definís usuarios, roles y permisos.</p>
			</article>
			<article class="step-card">
				<span>02</span>
				<h3>Registro de la gestión</h3>
				<p>Cargás clientes, datos clave y cada tarea o proceso que necesitás administrar.</p>
			</article>
			<article class="step-card">
				<span>03</span>
				<h3>Seguimiento y control</h3>
				<p>Actualizás estados, presupuestos, cobros y movimientos con información centralizada.</p>
			</article>
			<article class="step-card">
				<span>04</span>
				<h3>Cierre y análisis</h3>
				<p>Consultás el historial, ordenás la operación y analizás indicadores desde el dashboard.</p>
			</article>
		</div>
	</div>
</section>